module.exports = __webpack_public_path__ + "img/dcom03.2659241d.png";